import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { bool, func, string } from 'prop-types';
import { ModalStyled, ModalActionsStyled, ButtonStyled, Box } from '@nike/nike-design-system-components';

import { removeContractDepartmentAssociation } from '../actions';
import { getIsSubmittingContractDeptChange } from '../selectors';

import LoadingAnimation from '../../../components/LoadingAnimation';

const RemoveDepartmentModal = ({
  isOpen,
  closeModal,
  departmentNumber,
  departmentName,
  contractNumber,
  contractId
}) => {
  const dispatch = useDispatch();

  const isRemoving = useSelector(getIsSubmittingContractDeptChange);

  return (
    <ModalStyled
      isOpen={isOpen}
      closeModal={closeModal}
      title='Remove Department Association'
      backdropCompProps={{ style: { backdropFilter: 'blur(4px)' } }}
      slots={{
        FooterSlot: (
          <ModalActionsStyled>
            <ButtonStyled
              type='submit'
              appearance='primary'
              onClick={() => dispatch(removeContractDepartmentAssociation({ departmentNumber, contractId }))}
            >
              Remove
            </ButtonStyled>
            <ButtonStyled type='button' appearance='secondary' onClick={closeModal}>
              Cancel
            </ButtonStyled>
          </ModalActionsStyled>
        )
      }}
    >
      <span>Are you sure you want to remove the association of </span>
      <span style={{ fontWeight: 'bold' }}>
        Department {departmentNumber} {departmentName}
      </span>
      <span> to </span>
      <span style={{ fontWeight: 'bold' }}>Contract {contractNumber}</span>?
      {isRemoving && (
        <Box
          data-testId='submitting-overlay'
          width='100%'
          height='75%'
          style={{
            position: 'absolute',
            top: '35%',
            left: '0',
            background: 'rgba(255, 255, 255, 0.7)',
            zIndex: '3'
          }}
        >
          <LoadingAnimation size='s' />
        </Box>
      )}
    </ModalStyled>
  );
};

RemoveDepartmentModal.propTypes = {
  isOpen: bool.isRequired,
  closeModal: func.isRequired,
  departmentNumber: string.isRequired,
  departmentName: string.isRequired,
  contractNumber: string.isRequired,
  contractId: string.isRequired
};

export default RemoveDepartmentModal;
